import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import type { ResourceColorPalette } from '../../../theme/tokens/resourcesColors';
import { Avatar } from '../../atoms/Avatar';

type Props = {
  resourceColor: ResourceColorPalette;
  children?: ReactNode;
};

const StyledAvatar = styled(Avatar)<{ ownerState: { resourceColor: ResourceColorPalette } }>(
  ({ ownerState }) => ({
    backgroundColor: ownerState.resourceColor.main,
    color: ownerState.resourceColor.contrastText,
  }),
);

export function ResourceAvatar(props: Props) {
  return (
    <StyledAvatar
      size="medium"
      ownerState={{ resourceColor: props.resourceColor }}
    >
      {props.children}
    </StyledAvatar>
  );
}

export type { Props as ResourceAvatarProps };
